import styled, { css } from 'styled-components';

export const TableContent = styled.div`
  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    text-align: left;
  }
  th {
    width: 160px;
    text-align: start;
    padding-right: 5px;
    padding-left: 5px;

    position: relative;
    border-bottom: 1px solid rgb(146, 146, 146);
    height: 35px;
    font-size: 15px;
    color: #000000;
    opacity: 1;

    &:first-child {
      padding-left: 20px;
    }
    &:last-child {
      padding-right: 20px;
    }
  }
  td {
    position: relative;
    text-align: start;
    padding-right: 5px;
    padding-left: 5px;
    border-bottom: 1px solid rgb(215, 215, 215);
    font-size: 15px;
    color: rgb(0, 0, 0);
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:first-child {
      padding-left: 20px;
    }
    &:last-child {
      padding-right: 20px;
    }
  }
  .resizer {
    display: none;
    /* position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: rgba(0, 0, 0, 0.2);
    cursor: col-resize;
    user-select: none;
    touch-action: none; */
  }

  .resizer.isResizing {
    background: blue;
    opacity: 1;
  }

  @media (hover: hover) {
    .resizer {
      opacity: 0;
    }

    *:hover > .resizer {
      opacity: 1;
    }
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      th {
        color: #ccc;
      }
      td {
        color: #fff;
      }
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background: var(--cp-surface);
      border: 1px solid var(--cp-border);
      border-radius: 12px;
      box-shadow: none;
      overflow-x: auto;
      max-width: 100%;
      th {
        height: 42px;
        background: var(--cp-surface-alt);
        color: var(--cp-text-secondary);
        font-size: 12px;
        font-weight: 600;
        &:last-child {
          padding-right: 20px;
        }
      }
      td {
        &:last-child {
          padding-right: 15px;
        }
      }
    `}
`;
